module.exports = __webpack_public_path__ + "img/love.b07284f6.png";